import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split('-')[0] || 'it';

  const content = {
    it: {
      copyright: "© 2025 L.S.C. SRL. Tutti i diritti riservati.",
      terms: "Termini e Condizioni",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy"
    },
    en: {
      copyright: "© 2025 L.S.C. SRL. All rights reserved.",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy"
    }
  };

  const c = content[lang] || content.en;

  return (
    <footer className="bg-slate-50 border-t border-slate-200 py-4 px-4">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500">
        <p>{c.copyright}</p>
        <nav className="flex items-center gap-4">
          <Link to="/terms" className="hover:text-slate-700 hover:underline">
            {c.terms}
          </Link>
          <span className="text-slate-300">|</span>
          <Link to="/privacy" className="hover:text-slate-700 hover:underline">
            {c.privacy}
          </Link>
          <span className="text-slate-300">|</span>
          <Link to="/cookies" className="hover:text-slate-700 hover:underline">
            {c.cookies}
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
